import nfetch from "@/utils/events/nfetch";

class DadosFranquiaRotuloService {
    protected cached: { [franquiaId: number]: string[] } = {};
    controllerName = "RotuloPersonalizado";

    public async getDadosFranquiaCached(franquiaId: number) {
        if (this.cached[franquiaId]) {
            return this.cached[franquiaId];
        }

        const response = await nfetch(`/${this.controllerName}/GetDadosFranquia?franquiaId=${franquiaId}`, {
            method: "get",
            credentials: "same-origin",
        })
            .withLoading()
            .resolveWithJSON<Promise<string[]>>();

        this.cached[franquiaId] = response;
        return response;
    }
}

export default new DadosFranquiaRotuloService();
